import BaseModelAPI from '../BaseModelAPI';

export default class PostingSupplyCase extends BaseModelAPI {
	static entity = 'postingsupplycase';
	static entityName = 'postingsupplycase';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.postingSupplyForProductionId = '';
			this.postingSupplyForProduction = {};
			this.postingSupplyDetailForProductionId = '';
			this.postingSupplyDetailForProduction = {};
			this.pickingSupplyDetailForProductionId = '';
			this.pickingSupplyDetailForProduction = {};
			this.controlCardId = '';
			this.controlCard = {};
			this.partId = '';
			this.part = {};
			this.qty = 0;
			this.areaId = '';
			this.area = {};
			this.rackId = '';
			this.rack = {};
			this.documentStatusId = '';
			this.documentStatus = {};
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.isScanned = '';
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}